<template>
  
  <h1>Seguimiento de envíos Just</h1>
  <div class="contentForm">
    <div class="contentForm-data" :class="trackNumber == '' ? '' : 'input-not-empty'">
      <input type="text" v-model="trackNumber" maxlength="7" id="trackNumberInput" class="contentForm-input" @keypress="validateOnlyNumbers"/>
      <label class="contentForm-label" for="trackNumberInput">
        Numero de la transaccion (requerido)
      </label>
      <small>El número está formado por 7 dígitos.</small>
    </div>

    <button class="contentForm-button" @click="checkTrackingStatus()" :disabled="trackNumber == '' || trackNumber.length < 7 || !/^\d+$/.test(trackNumber)">
      <span class="contentForm-span">Consultar</span>
    </button>
  </div>
  <div v-if="orderSearching">
    <span class="loader"></span>
  </div>
  
  <template v-if="orderSearched && !orderSearching && !requestError">
  <div v-if="trackingInfo != null && trackingInfo.listaEstados.length > 0" class="statusShippings">
    <h2>
      Estados del envío dirigido a: {{ trackingInfo.destinatario_localidad }}
    </h2>
    <ol class="progress">
      <li v-for="(item,idx) in trackingInfo.listaEstados" :key="idx">
        <div class="progress-content">
          <p>{{item.estado}}</p>
          <span>{{item.fecha}}</span>
        </div>
      </li>
    </ol>
  </div>
  <div v-else class="statusShippings status_error">
    <span>El número de transacción Just no fue encontrado ebge gbe tgbet</span>
  </div>
  </template>
  <div v-if="requestError" class="statusShippings status_error">
    <span>{{requestErrorMessage}}</span>
  </div>
  
      
</template>

<script>
    import { useStore } from 'vuex';
    import { onMounted, ref, onBeforeUnmount } from 'vue'
    import { useRoute } from 'vue-router';
    import { useI18n } from 'vue-i18n';
    export default {
        components: {

        },
        setup(){
            const store = useStore();
            const route = useRoute();
            const trackingInfo = ref(null)
            const trackNumber = ref("")
            const requestErrorMessage = ref("")
            const orderSearched = ref(false)
            const orderSearching = ref(false)
            const requestError = ref(false)
            const { t } = useI18n();

            function validateOnlyNumbers(evt) {
              var theEvent = evt || window.event;

              // Handle paste
              if (theEvent.type === 'paste') {
                  key = event.clipboardData.getData('text/plain');
              } else {
              // Handle key press
                  var key = theEvent.keyCode || theEvent.which;
                  key = String.fromCharCode(key);
              }
              var regex = /[0-9]|\./;
              if( !regex.test(key) ) {
                theEvent.returnValue = false;
                if(theEvent.preventDefault) theEvent.preventDefault();
              }
            }

            async function checkTrackingStatus(){
              orderSearching.value = true
              requestError.value = false
                try {
                  let req = await store.dispatch('tracking_orders',trackNumber.value)
                  orderSearched.value = true
                  orderSearching.value = false
                  trackingInfo.value = req.data
                    
                } catch (error) {
                  orderSearching.value = false
//INVALID_TRACKINGID
                  const requestErrors = ['ERROR_AMDM_SERVICE','ERROR_GETTING_ADDRESS','ADDRESS_NOT_FOUND','INVALID_TRACKINGID'];
                  if(error.response.data && requestErrors.includes(error.response.data.message))
                  {
                    orderSearched.value = true
                    trackingInfo.value = null
                    requestErrorMessage.value = t(`requestError.${error.response.data.message}`)
                    console.log(t(`requestError.${error.response.data.message}`))
                  }
                  else
                  {
                    console.log(t('requestError.GENERIC_ERROR'))
                    requestErrorMessage.value = t('requestError.GENERIC_ERROR')
                  }
                  requestError.value = true
                }
            }
            onMounted(() => {
              if(route.params.trackNumber)
              {
                trackNumber.value = route.params.trackNumber
                checkTrackingStatus()
              }
            })
            function onKeydown (event) {
              if (event.key === 'Enter' && trackNumber.value != '' && trackNumber.value.length == 7 && /^\d+$/.test(trackNumber.value)) {
                checkTrackingStatus();
              }
            }
            window.addEventListener('keydown', onKeydown);
            onBeforeUnmount(() => {
              window.removeEventListener('keydown', onKeydown);
            })
            return {
              trackingInfo,
              checkTrackingStatus,
              trackNumber,
              orderSearched,
              validateOnlyNumbers,
              requestError,
              requestErrorMessage,
              orderSearching,
              onKeydown
            }
        }
    }
</script>

<style lang="scss">
@import "@/styles/main.scss";

</style>